import React, { useState } from "react";
import Button from "../../common/button";
import { useUserActionMutation } from "../../../store/api/userApi";
import { ROUTES } from "../../../constants/routes";
import { Link } from "react-router-dom";
import { toastError } from "../../toast";
import ProfileImageComp from "../../common/profile";
import ProfileBadgeAvatar from "../../user/user-profile/profile-avatar";

interface UserCardProps {
  userId: string;
  firstName: string;
  lastName: string;
  title: string;
  location: string;
  imageSrc: string;
  banner?: string;
  following?: boolean;
  self?: boolean;
  is_opc?: boolean;
  badge?: string;
}

const UserCard: React.FC<UserCardProps> = ({
  userId,
  firstName,
  lastName,
  title,
  location,
  imageSrc,
  banner,
  following,
  self,
  is_opc = false,
  badge,
}) => {
  const [triggerUserAction] = useUserActionMutation();
  const [isFollow, setIsFollow] = useState(following);
  const action = async ({ type }: { type: string }) => {
    try {
      setIsFollow(!isFollow);
      await triggerUserAction({ user_id: userId, action: type });
    } catch (error) {
      setIsFollow(!isFollow);
      toastError({ message: error });
    }
  };
  return (
    <div
      className={`flex-grow bg-white rounded-[10px] border border-gray-200 flex flex-col mb-4 ${self && "hidden"}`}
    >
      <div className="h-24 bg-blue-200 relative rounded-t-[10px]">
        {banner && (
          <img
            src={banner}
            alt="Background"
            className="w-full h-full rounded-t-[10px] object-cover"
          />
        )}
        <div className="absolute bottom-0 left-1/2 transform -translate-x-1/2 translate-y-1/2">
          <Link to={ROUTES.USER_PROFILE.replace(":user_id", userId)}>
            {badge ? (
              <div className={`relative w-16 h-[64px] mr-2`}>
                <ProfileBadgeAvatar
                  profileImage={imageSrc}
                  customDivClassName="absolute h-16 w-16 border-4 z-1"
                  customImgClassName="h-[64px] w-[64px] absolute rounded-full p-1"
                  customIconDivClassName="absolute z-[11] -bottom-1.5 left-[24px]"
                  customStyle1="w-[50px] h-5 absolute -bottom-2 z-[11] overflow-hidden"
                  customStyle2="w-[200px] h-6  absolute top-5 z-10 -left-10 overflow-hidden"
                  customStarWidth={16}
                  customStarHeight={16}
                  customStyle3="w-[56px] h-[56px]"
                  badge={badge}
                />
              </div>
            ) : (
              <ProfileImageComp
                imageUrl={imageSrc}
                customClass="h-16 w-16"
                is_opc={is_opc}
              />
            )}
          </Link>
        </div>
      </div>
      <div className="mt-10 px-4 text-center flex-grow flex flex-col justify-between">
        <div>
          <Link to={ROUTES.USER_PROFILE.replace(":user_id", userId)}>
            <h3 className="font-semibold text-lg">
              {firstName} {lastName}
            </h3>
            <p className="text-sm text-gray-600 mt-1">{title}</p>
            <p className="text-sm text-gray-500 mt-1">{location}</p>
          </Link>
        </div>
      </div>
      <div className="flex justify-center mb-4 mt-4">
        {isFollow ? (
          <Button
            customClasses={`px-[56px] py-2 rounded-[12px] cursor-pointer`}
            variant="secondary"
            onClick={() => action({ type: "unfollow" })}
          >
            Following
          </Button>
        ) : (
          <Button
            customClasses={`px-[60px] py-2 rounded-xl cursor-pointer`}
            onClick={() => action({ type: "follow" })}
          >
            Follow
          </Button>
        )}
      </div>
    </div>
  );
};
export default UserCard;
